import { Action } from 'redux';
import { IExtractTaskInfo } from '../../../ts/models/IExtractTaskInfo';
import { DeleteExtractRefresh } from '../AppActionTypes';

export interface DeleteExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function deleteExtractRefresh(tasks: IExtractTaskInfo[]): DeleteExtractRefreshAction {
  return {
    type: DeleteExtractRefresh,
    tasks
  };
}
